import { createBrowserHistory } from 'history';

const history = createBrowserHistory();

export default history;
(window as any).__history = history;
